import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ContactSupport.css';

const ContactSupport = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
      
      // Reset status after 3 seconds
      setTimeout(() => {
        setSubmitStatus('');
      }, 3000);
    }, 1500);
  };

  return (
    <div className="contact-container">
      <main className="contact-content">
        <section className="contact-section">
          <h2 className="section-title">Contact Support</h2>
          <p className="text">
            We're here to help! Get in touch with our support team for any questions, 
            concerns, or assistance you may need.
          </p>
        </section>

        <section className="contact-section">
          <h2 className="section-title">Get in Touch</h2>
          
          <div className="contact-methods">
            <div className="contact-method">
              <div className="contact-icon">📧</div>
              <h3>Email Support</h3>
              <p>support@only2u.com</p>
              <p className="response-time">Response within 24 hours</p>
            </div>

            <div className="contact-method">
              <div className="contact-icon">📞</div>
              <h3>Phone Support</h3>
              <p>+91 98111 50757</p>
              <p className="response-time">Available Mon-Fri, 9 AM - 6 PM IST</p>
            </div>

            <div className="contact-method">
              <div className="contact-icon">💬</div>
              <h3>Live Chat</h3>
              <p>Coming Soon</p>
              <p className="response-time">Real-time support</p>
            </div>
          </div>
        </section>

        <section className="contact-section">
          <h2 className="section-title">Send us a Message</h2>
          
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Full Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
                placeholder="Enter your full name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                placeholder="Enter your email address"
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject *</label>
              <select
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleInputChange}
                required
              >
                <option value="">Select a subject</option>
                <option value="general">General Inquiry</option>
                <option value="technical">Technical Support</option>
                <option value="billing">Billing & Payment</option>
                <option value="privacy">Privacy & Data</option>
                <option value="feature">Feature Request</option>
                <option value="bug">Bug Report</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="message">Message *</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                required
                rows="6"
                placeholder="Please describe your issue or question in detail..."
              />
            </div>

            <button 
              type="submit" 
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>

            {submitStatus === 'success' && (
              <div className="success-message">
                Thank you! Your message has been sent successfully. We'll get back to you soon.
              </div>
            )}
          </form>
        </section>

        <section className="contact-section">
          <h2 className="section-title">Frequently Asked Questions</h2>
          
          <div className="faq-list">
            <div className="faq-item">
              <h3>How does the AI face swap feature work?</h3>
              <p>Our AI technology allows you to visualize fashion products on your face by swapping your face onto model images. Simply upload a photo and select products to see how they look on you.</p>
            </div>

            <div className="faq-item">
              <h3>Is my personal data secure?</h3>
              <p>Yes, we take data security seriously. All personal information and images are encrypted and stored securely. We never share your data with third parties without your consent.</p>
            </div>

            <div className="faq-item">
              <h3>Can I delete my account and data?</h3>
              <p>Absolutely. You can delete your account and all associated data at any time through your account settings. We'll permanently remove all your information from our systems.</p>
            </div>

            <div className="faq-item">
              <h3>What payment methods do you accept?</h3>
              <p>We accept all major credit cards, debit cards, and digital wallets including UPI, Google Pay, and Apple Pay for Indian customers.</p>
            </div>
          </div>
        </section>

        <section className="contact-section">
          <h2 className="section-title">Office Address</h2>
          <div className="office-info">
            <p><strong>Only2U Technologies Pvt. Ltd.</strong></p>
            <p>123 Fashion Street</p>
            <p>Mumbai, Maharashtra 400001</p>
            <p>India</p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default ContactSupport;
